import { useContext } from "react";
import { ShellContext } from "./ShellContext";
import type { ShellState } from "./types";

export function useShell(): ShellState {
  const context = useContext(ShellContext);
  if (context === undefined) {
    throw new Error("useShell must be used within a ShellProvider");
  }
  return context;
}
